import React from 'react'
import {
    Tabs
} from "antd"
import ActivityList from "../../common/activityList/list"
import OrderList from '../../common/order/orderList'
import GroupManage from '../../common/groupManage/index'
import ActivityData from '../../common/dataManage/index'

const {TabPane} = Tabs;
import {Path} from "../../../../public/path";

class GroupByManage extends React.Component {
    constructor(props) {
        super(props);

        this.getVal = this.getVal.bind(this)
        this.changeTabs = this.changeTabs.bind(this)
        this.gotoProfit = this.gotoProfit.bind(this)
        this.gotoRank = this.gotoRank.bind(this);

        this.state = {
            activeKey: "0",
            distriId: 0,
            profitActive: "1"
        }
    }

    componentDidMount() {
        let activeKey = this.props.match.params.id
        this.getVal("activeKey", activeKey)

    }

    componentWillReceiveProps(nextProps) {
        let activeKey = nextProps.match.params.id
        this.getVal("activeKey", activeKey)
    }

    /*
   * 获取列表
   * */
    getVal(key, val) {
        this.setState({
            [key]: val
        })
    }

    /*
   * tab切换
   * */
    changeTabs(activeKey) {
        this.getVal("distriId", 0)
        this.setState({
            activeKey: activeKey
        })
        this.props.history.push(Path.getGroupBuyLadderActivityManagePage() + activeKey)
    }

    /*
   * 前去收益
   * */
    gotoProfit(activeKey, id) {
        this.changeTabs(activeKey)
        this.getVal("distriId", id)
    }

    /*
   * 前去排行
   * */
    gotoRank(activeKey, id) {
        this.changeTabs(activeKey)
        this.getVal("distriId", id)
    }


    render() {
        return (
            <div className={'contentBody'}>
                <div className={'qy-panel minHeightNormal goodsListCon distriList '}>
                    <Tabs animated={false}
                          className="mxd-tabs rechargeTabs minHeightNormal"
                          activeKey={this.state.activeKey}
                          onChange={this.changeTabs.bind(this)}
                    >
                        <TabPane tab="活动管理" key={"1"}>
                            {
                                this.state.activeKey == 1 ?
                                    <ActivityList
                                        type={'ladder'}
                                        props={this.props}
                                        gotoProfit={this.gotoProfit}
                                        activeKey={this.state.activeKey}
                                        type={'ladder'}
                                    />
                                    : ''
                            }
                        </TabPane>
                        <TabPane tab="订单管理" key={"2"}>
                            {
                                this.state.activeKey == 2 ?
                                    <OrderList
                                        type={'ladder'}
                                        props={this.props}
                                        gotoProfit={this.gotoProfit}
                                        activeKey={this.state.activeKey}
                                    />
                                    : ''
                            }
                        </TabPane>
                        <TabPane tab="活动数据" key={"3"}>
                            {
                                this.state.activeKey == 3 ?
                                    <ActivityData
                                        type={'ladder'}
                                        props={this.props}
                                        gotoProfit={this.gotoProfit}
                                        activeKey={this.state.activeKey}
                                    />
                                    : ''
                            }
                        </TabPane>
                        <TabPane tab="拼团情况" key={"4"}>
                            {
                                this.state.activeKey == 4 ?
                                    <GroupManage
                                        type={'ladder'}
                                        props={this.props}
                                        gotoProfit={this.gotoProfit}
                                        activeKey={this.state.activeKey}
                                    />
                                    : ''
                            }
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        )
    }

}

export default GroupByManage;